import boolean from "shapefile/dbf/boolean";

const ESchemaDayaDukung = Object.freeze([

    //REFERENSI SCHEMA YANG AKAN DI BUAT EXPORTNYA
    // id,
    // kode1="",
    // description ="",
    // fdivisionBean =0,
    // statusActive =true,
    // baseId,
    // lang,
    //
    // fdayaDukungTypeBean =0,
    //
    // fareaBean=0,
    // tahun="",
    // lat=0.0,
    // lon=0.0,
    // notes = "",
    //
    // nilai1 = 0.0,
    // nilai2 = 0.0,
    // nilai3 = 0.0,
    // nilai4 = 0.0,
    // nilai5 = 0.0,
    //
    // nilaiInt1 = 0,
    // nilaiInt2 = 0,

    {
        column: 'Nomor',
        type: Number,
        value: item => item.id
    },
    {
        column: 'Division',
        type: String,
        width:15,
        value: item => item.fdivision.kode1
    },

    {
        column: 'Kode',
        type: String,
        value: item => item.kode1
    },
    {
        column: 'Description',
        type: String,
        width:20,
        value: item => item.description
    },
    {
        column: 'Jenis',
        type: String,
        width:10,
        value: item => item.fdayaDukungType.description
    },
    {
        column: 'Kecamatan',
        type: String,
        width:10,
        value: item => item.farea.description
    },
    {
        column: 'Tahun',
        type: Number,
        width:10,
        value: item => item.tahun
    },
    {
        column: 'Latitude',
        type: Number,
        format: '#,##0',
        value: item => item.lat
    },
    {
        column: 'Longitude',
        type: Number,
        format: '#,##0',
        value: item => item.lon
    },
    {
        column: 'Nilai1',
        type: Number,
        width: 15,
        format: '#,##0',
        value: item => item.nilai1
    },
    {
        column: 'Nilai2',
        type: Number,
        width: 15,
        format: '#,##0',
        value: item => item.nilai2
    },
    {
        column: 'Nilai3',
        type: Number,
        format: '#,##0',
        value: item => item.nilai3
    },
    {
        column: 'Nilai4',
        type: Number,
        format: '#,##0',
        value: item => item.nilai4
    },
    {
        column: 'Nilai5',
        type: Number,
        format: '#,##0',
        value: item => item.nilai5
    },
    {
        column: 'NilaiInt1',
        type: Number,
        value: item => item.nilaiInt1
    },
    {
        column: 'NilaiInt2',
        type: Number,
        value: item => item.nilai2
    },
    {
        column: 'statusActive',
        type: boolean,
        value: item => item.statusActive
    },


    // {
    //     column: 'remarkInt1',
    //     type: Number,
    //     width:25,
    //     value: item => item.remarkInt1
    // },
    // {
    //     column: 'remarkDouble1',
    //     type: Number,
    //     format: '#,##0',
    //     width:25,
    //     value: item => item.remarkDouble1
    // },
    //

    {
        column: 'Lon',
        type: Number,
        format: '#,##0',
        value: item => item.lat
    },
    {
        column: 'Lon',
        type: Number,
        format: '#,##0',
        value: item => item.lon
    },

])


export default ESchemaDayaDukung